import React from "react";
import { Outlet } from "react-router-dom";
import { GsdStandaloneModuleLayout } from "@/coquille-bridge";
import { AdminGuard } from "@/components/admin/AdminGuard.jsx";
import { mapShotokanItemsToTabs, renderShotokanNavLink } from "@/pages/shotokanBlackDragon/ShotokanBlackDragonSubNav.jsx";
import {
  ADMIN_SHOTOKAN_BASE,
  ADMIN_SHOTOKAN_SUB_NAV,
  SENSEI_SHOTOKAN_BASE,
  SENSEI_SHOTOKAN_SUB_NAV,
  SEMPAI_SHOTOKAN_BASE,
  SEMPAI_SHOTOKAN_SUB_NAV,
  SHOTOKAN_MODULE_EN,
  SHOTOKAN_MODULE_FR,
} from "@/pages/shotokanBlackDragon/shotokanNavConfig.js";
import { useI18n } from "@/coquille-bridge";

function useLocale() {
  const { lang } = useI18n();
  return lang === "en" ? "en" : "fr";
}

function ShotokanModuleShell({ basePath, items, testId, subNavTestId }) {
  const locale = useLocale();
  return (
    <GsdStandaloneModuleLayout
      title={{ labelFr: SHOTOKAN_MODULE_FR, labelEn: SHOTOKAN_MODULE_EN }}
      basePath={basePath}
      tabs={mapShotokanItemsToTabs(items)}
      lang={locale}
      moduleTestId={testId}
      testId="gsd-shotokan-module-layout"
      subNavTestId={subNavTestId}
      renderTabLink={renderShotokanNavLink}
    >
      <Outlet />
    </GsdStandaloneModuleLayout>
  );
}

export function ShotokanBlackDragonAdminLayout() {
  return (
    <AdminGuard>
      <ShotokanModuleShell
        basePath={ADMIN_SHOTOKAN_BASE}
        items={ADMIN_SHOTOKAN_SUB_NAV}
        testId="shotokan-admin-module"
        subNavTestId="shotokan-black-dragon-subnav"
      />
    </AdminGuard>
  );
}

export function ShotokanBlackDragonSenseiLayout() {
  return (
    <ShotokanModuleShell
      basePath={SENSEI_SHOTOKAN_BASE}
      items={SENSEI_SHOTOKAN_SUB_NAV}
      testId="shotokan-sensei-module"
      subNavTestId="shotokan-sensei-subnav"
    />
  );
}

export function ShotokanBlackDragonSempaiLayout() {
  return (
    <ShotokanModuleShell
      basePath={SEMPAI_SHOTOKAN_BASE}
      items={SEMPAI_SHOTOKAN_SUB_NAV}
      testId="shotokan-sempai-module"
      subNavTestId="shotokan-sempai-subnav"
    />
  );
}
